import { render, staticRenderFns } from "./IconFileImage.vue?vue&type=template&id=19828a20&"
import script from "./IconFileImage.vue?vue&type=script&lang=ts&"
export * from "./IconFileImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports